import { ObjectContainerClientT } from 'bovaljaren-models';
import React, { ReactElement } from 'react';
import { ToggleValuesT } from '../ObjectView';
import { CurrentImageT } from '../OV-subcomponents';

type ObjectViewFloorplanImageProps={
    currentImages?: CurrentImageT[];
    selectedObject?: ObjectContainerClientT;
    setImageIndex: (value: number) => void;
    setPrevImageIndex: (value: number) => void;
    toggleShow: (value: ToggleValuesT) => void;
    imageIndex: number;
};

const ObjectViewFloorplanImage: React.FC<ObjectViewFloorplanImageProps> = ({ currentImages, selectedObject, setImageIndex, setPrevImageIndex, imageIndex, toggleShow }): ReactElement => {
    return (
        <>
            {(currentImages && currentImages.filter(fc => fc.subtype === 'floorplan').length > 0) && <div className='bv-objectview-floorplan-container'>
                <div className='bv-objectview-floorplan-container-sub'>
                    {selectedObject && currentImages?.filter(fc => fc.subtype === 'floorplan')?.map((f, i) => {
                        return i === 0 && f.image.type === 'image' && <img key={f.image.id}
                            className={'bv-objectview-floorplan'}
                            alt='floorplan'
                            src={f.image.url?.small as unknown as string}
                            onClick={(): void => {
                                currentImages && setImageIndex(currentImages.indexOf(f));
                                currentImages && setPrevImageIndex(imageIndex);
                                toggleShow('images');
                            }}/>;
                    })}
                </div>
            </div>}
        </>

    );
};


export default ObjectViewFloorplanImage;